module.exports = __webpack_public_path__ + "static/media/MapnamaBBAF2colorized.c94a2510.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/floormap/MapnamaBBAF2colorized.jpg
// module id = 277
// module chunks = 0